module.exports = __webpack_public_path__ + "static/media/iconOne.12252444.svg";